import {Entidade} from "./Entidade";
import RestauranteHorarioFuncionamento from "./RestauranteHorarioFuncionamento";

export default class RestauranteHorarioFuncionamentoPeriodo extends Entidade {

    restauranteHorarioFuncionamento?: RestauranteHorarioFuncionamento;
    horaInicio?: string;
    horaFim?: string;
    delivery?: boolean;

}